/* ═══════════════════════════════════════════════════════════════
   Single source for all data-swatch palettes (user-pickable colors
   persisted as data). App chrome colors live in base.css tokens —
   never add chrome colors here.
   ═══════════════════════════════════════════════════════════════ */

/** Admin Center → Titles (billing roles). Quick-pick swatches offered
 *  when assigning a Title's badge color. */
export const TITLE_COLORS = [
  '#2563eb',
  '#059669',
  '#d97706',
  '#7c3aed',
  '#dc2626',
  '#0891b2',
  '#db2777',
  '#65a30d',
  '#ea580c',
  '#6366f1',
  '#0d9488',
  '#a855f7',
];

/** Admin Center → Departments. Quick-pick swatches for department color. */
export const DEPARTMENT_COLORS = [
  '#2563eb', // blue
  '#059669', // green
  '#d97706', // amber
  '#7c3aed', // violet
  '#dc2626', // red
  '#0891b2', // cyan
  '#db2777', // pink
  '#65a30d', // lime
  '#ea580c', // orange
  '#6366f1', // indigo
  '#0d9488', // teal
  '#a855f7', // purple
];

/** Admin Center → Project Scopes. Default color rotation for new scopes. */
export const DEFAULT_SCOPE_COLORS = [
  '#2563eb',
  '#059669',
  '#d97706',
  '#dc2626',
  '#7c3aed',
  '#db2777',
  '#0891b2',
  '#65a30d',
  '#ea580c',
  '#6366f1',
];

/** Team page → named Teams. Quick-pick swatches for team color. */
export const TEAM_COLORS = [
  '#4A90D9',
  '#D94A4A',
  '#4AD97A',
  '#D9A84A',
  '#9B59B6',
  '#1ABC9C',
  '#E67E22',
  '#3498DB',
  '#E74C3C',
  '#2ECC71',
  '#F39C12',
  '#8E44AD',
  '#16A085',
  '#C0392B',
];

/** Team page → org-chart edge (reporting-line) colors. First entry is the
 *  theme border token so default lines follow the theme; the rest are
 *  user-pickable line colors persisted per edge. */
export const ORG_EDGE_COLORS = [
  'var(--bd)',
  '#4a90d9',
  '#3aa86b',
  '#e1a92d',
  '#d96a4a',
  '#a360d9',
  '#666',
];

/** Forecasting → project color-coding. 12 distinct hues from Tailwind
 *  600s, picked for accessible contrast on both light and dark themes. */
export const PROJECT_PALETTE = [
  '#2563eb',
  '#059669',
  '#d97706',
  '#7c3aed',
  '#dc2626',
  '#0891b2',
  '#db2777',
  '#65a30d',
  '#ea580c',
  '#6366f1',
  '#0d9488',
  '#a855f7',
];
